import React, { Component } from "react";
import "./Profile.css";
import { getUserData } from "../../utils/user";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      bounties: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        },
        {
          id: 4
        },
        {
          id: 5
        },
        {
          id: 6
        },
        {
          id: 7
        }
      ]
    };
  }

  componentDidMount = async () => {
    const { data, status } = await getUserData(true);

    if (status === 200) {
      this.setState({
        ...data
      });
    }
  };

  render() {
    const { bounties } = this.state;

    return (
      <div className="profile-container">
        <div className="profile-user-information shadowed">
          <div className="profile-user-information-label">My profile</div>
          <div className="profile-user-wallet-container shadowed">
            <div className="profile-user-information-label">Balance: $0.00</div>
          </div>
        </div>
        <div className="profile-user-bounties-container">
          <div>Bounties</div>
          <div className="profile-user-bounty-list">
            <div
              style={{
                fontSize: "1.5rem",
                marginTop: "1rem",
                marginLeft: "1rem"
              }}
            >
              No bounties posted yet
            </div>
          </div>
        </div>
      </div>
    );
  }
}
